import React from 'react';
import '../Style/Footer.css';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Sahibinden from '../image/Sahibinden.Logo.png';

function Footer() {
  return (
        <div className='footer'>
            <div className='socialMedia'>
              <a href="https://www.youtube.com/@emlakcinn"><YouTubeIcon href="" style={{color:'red'}}/></a>
              <a href="https://www.facebook.com/share/1BBqDbdAdU/?mibextid=LQQJ4d"><FacebookIcon style={{color:'#1888ff'}}/></a>
              <a href="https://www.instagram.com/emlakcinn"><InstagramIcon style={{color:'rgb(221, 42, 123)'}}/></a>
              <a href="https://x.com/emlakcinn"><TwitterIcon style={{color:'#1888ff'}}/></a>
              <a href="https://api.whatsapp.com/send?phone=905322005989" target='_blank'><WhatsAppIcon style={{color:'rgb(37, 211, 102)'}}/></a>
              
            </div>
            <p className='tradeMarke'>www.emlakcinn.com | <span><i>aikim Kuruluşudur</i></span></p>
        </div>
        
  )
}

export default Footer;

//<a href="https://imparatoremlak.sahibinden.com/emlak?sorting=date_desc"><img src={Sahibinden} alt="" className='sahibindenLogo'/></a>